import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileNumericInputControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        element.css('line-height', 'normal');
    }
}

const mobileNumericInputControlView = new MobileNumericInputControlView();
export default mobileNumericInputControlView;